"use strict";

var _classCallCheck = require("/home/jenkins/agent/workspace/rtal_Jobs_Portal_Pipeline_master/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/home/jenkins/agent/workspace/rtal_Jobs_Portal_Pipeline_master/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var moment_1 = __importDefault(require("moment"));

var moment_range_1 = require("moment-range");

require("moment/locale/es");

var moment = moment_range_1.extendMoment(moment_1.default);
moment.locale('es');
moment.updateLocale('es', {
  monthsShort: ['Ene', 'Feb', 'Mar', 'Abr', 'May', 'Jun', 'Jul', 'Ago', 'Sep', 'Oct', 'Nov', 'Dic']
});

var DateUtils = /*#__PURE__*/function () {
  function DateUtils() {
    _classCallCheck(this, DateUtils);
  }

  _createClass(DateUtils, [{
    key: "getNow",
    value: function getNow() {
      var date = moment().toISOString();
      return date;
    }
  }, {
    key: "daysBetween",
    value: function daysBetween(date1, date2) {
      // Get 1 day in milliseconds
      var oneDayInMs = 1000 * 60 * 60 * 24; // Convert both dates to milliseconds

      var date1InMs = date1.getTime();
      var date2InMs = date2.getTime(); // Calculate the difference in milliseconds

      var differenceInMs = Math.abs(date2InMs - date1InMs); // Convert back to days and return

      return Math.round(differenceInMs / oneDayInMs);
    }
  }, {
    key: "obtenerFecha",
    value: function obtenerFecha(cantidadDias) {
      var date = new Date();
      date.setDate(date.getDate() + cantidadDias);
      return date;
    }
    /**
     *
     * @param {fecha en formato yyyy-MM-dd} fechaStr
     */

  }, {
    key: "parsearFecha",
    value: function parsearFecha(fechaStr) {
      var dateSplitted = fechaStr.split('-');
      return new Date(dateSplitted[2], dateSplitted[1] - 1, dateSplitted[0]);
    }
    /**
     *
     * @param {fecha en formato yyyy-MM-dd} fechaStr
     * @return {number} days
     * @return {number} months
     * @return {number} years
     */

  }, {
    key: "getDuration",
    value: function getDuration(dateStr) {
      var start = moment(dateStr, 'DD/MM/YYYY');
      var end = moment();
      var duration = moment.duration(end.diff(start)); // eslint-disable-next-line no-underscore-dangle

      return duration._data;
    }
    /**
     *
     * @param {fecha en formato yyyy-MM-dd} fechaStr
     */

  }, {
    key: "getNumberOfDays",
    value: function getNumberOfDays(fecha) {
      var cantidadDeDias = this.getTiempoPublicado(fecha);
      var fechaFormateada = moment(fecha, 'DD-MM-YYYY').toDate();
      var fechaPublicacionDiaDeMes = moment(fechaFormateada).format('D [de] MMMM');

      if (cantidadDeDias === 0) {
        return 'Hoy';
      }

      if (cantidadDeDias === 1) {
        return 'Ayer';
      }

      if (cantidadDeDias > 1 && cantidadDeDias <= 3) {
        return "hace ".concat(cantidadDeDias, " d\xEDas");
      }

      return "el ".concat(fechaPublicacionDiaDeMes);
    }
    /**
     *
     * @param {fecha en formato DD-MM-YYYY} fechaStr
     */

  }, {
    key: "getTiempoPublicado",
    value: function getTiempoPublicado(fecha) {
      var hoy = moment(new Date(), 'DD-MM-YYYY');
      return Math.abs(hoy.diff(moment(fecha, 'DD-MM-YYYY'), 'days'));
    }
  }, {
    key: "getTimeBetween",
    value: function getTimeBetween(startTime, endTime) {
      var yearsDiff = endTime.diff(startTime, 'years');
      startTime.add(yearsDiff, 'years');
      var monthsDiff = endTime.diff(startTime, 'months');
      return {
        years: yearsDiff,
        months: monthsDiff
      };
    }
  }, {
    key: "getLapsedTimeText",
    value: function getLapsedTimeText(fechaInicio, fechaFin) {
      var startTime = moment(fechaInicio, 'DD-MM-YYYY');
      var endTime = fechaFin ? moment(fechaFin, 'DD-MM-YYYY') : moment();
      var timeBetween = this.getTimeBetween(startTime, endTime);
      if (timeBetween.years > 0 && timeBetween.months > 0) return "".concat(timeBetween.years, " ").concat(timeBetween.years === 1 ? 'año' : 'años', " y ").concat(timeBetween.months, " ").concat(timeBetween.months === 1 ? 'mes' : 'meses');
      if (timeBetween.years > 0 && timeBetween.months === 0) return "".concat(timeBetween.years, " ").concat(timeBetween.years === 1 ? 'año' : 'años');
      return "".concat(timeBetween.months, " ").concat(timeBetween.months === 1 ? 'mes' : 'meses');
    }
  }, {
    key: "getTimeText",
    value: function getTimeText(fechaInicio, fechaFin) {
      var startDate = moment(fechaInicio, 'DD-MM-YYYY').format('MMM YYYY');
      var endDate = fechaFin ? moment(fechaFin, 'DD-MM-YYYY').format('MMM YYYY') : 'Actualidad';
      return "".concat(startDate, " - ").concat(endDate);
    }
  }]);

  return DateUtils;
}();

exports.dateUtils = new DateUtils();